// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_array from "../../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as DefaultCarouselIndicatorsModuleScss from "../styles/DefaultCarouselIndicators.module.scss";

var defaultStyles = DefaultCarouselIndicatorsModuleScss;

function CarouselIndicatorsCmp(Props) {
  var currentSlide = Props.currentSlide;
  var totalSlides = Props.totalSlides;
  var setSlide = Props.setSlide;
  var stylesOpt = Props.styles;
  var isClickable = Props.isClickable;
  var styles = stylesOpt !== undefined ? Caml_option.valFromOption(stylesOpt) : defaultStyles;
  var buttons = Caml_array.make(totalSlides, undefined);
  return React.createElement("div", {
              className: styles["carousel-indicators"]
            }, buttons.map(function (param, index) {
                  return React.createElement("div", {
                              key: "button-" + String(index),
                              className: "" + styles["carousel-indicator-item"] + " " + (
                                index === currentSlide ? styles["carousel-indicator-item-active"] : ""
                              ) + "",
                              onClick: (function (param) {
                                  if (isClickable) {
                                    return Curry._1(setSlide, index);
                                  }
                                  
                                })
                            });
                }));
}

var make = CarouselIndicatorsCmp;

export {
  defaultStyles ,
  make ,
}
/* defaultStyles Not a pure module */
